import { FormattedMessage } from 'react-intl';

import { BaseAutocompleteSuggestionType } from '../../../../common/components/autocomplete-list/pool-autocomplete-list';
import { PoolFormAutocompleteList } from '../../../../common/components/abstract/form-autocomplete-list';
import { RegionWithId } from '../../../../common/models/region';

export interface PartialRegion extends BaseAutocompleteSuggestionType, Pick<RegionWithId, 'name'> {}

export class RegionAutocompleteList extends PoolFormAutocompleteList<RegionWithId, PartialRegion> {
    public label = (<FormattedMessage id="app.label.region" />);
    public getDisplayValue = (country: RegionWithId) => {
        return country.name;
    };
    public getSuggestionValue = (suggestion: PartialRegion) => suggestion?.name;
    public getPartial = (items: RegionWithId[]): PartialRegion[] => {
        return items.map(region => {
            return {
                id: region.id,
                name: region.name,
            };
        });
    };
}
